import { ReactNode } from 'react'
import { JourneyStepType } from '../../../types'
import { ActionStepIcon, CheckCircleIcon, CloseIcon, DelayStepIcon, EntranceStepIcon, ForbiddenIcon } from '../../../ui/icons'
import * as journeySteps from '../steps/index'

export const getStepType = (type: string) => (type ? journeySteps[type as keyof typeof journeySteps] as JourneyStepType : null) ?? null

export const statIcons: Record<string, ReactNode> = {
    action: <ActionStepIcon />,
    delay: <DelayStepIcon />,
    completed: <CheckCircleIcon />,
    error: <ForbiddenIcon />,
    entrance: <EntranceStepIcon />,
    ended: <CloseIcon />,
}

export const stepCategoryColors = {
    entrance: 'red',
    action: 'blue',
    flow: 'green',
    delay: 'yellow',
    exit: 'red',
    info: 'purple',
}

export const DATA_FORMAT = 'application/parcelvoy-journey-step'
export const STEP_STYLE = 'smoothstep'
